"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats a price value without currency and decimals.
 * // Adds comma
 * eg. 250, 2500
 * Will be used by price per day on listing page card
 * @param value
 * @param currency
 * @returns
 */
function formatPriceWithoutDecimals(value) {
    return value.split(/\./)[0];
}
exports.default = formatPriceWithoutDecimals;
